
import { client } from '../data/api/client/client';
import { getCurrentUser, getCurrentUserId } from './getCurrentUser';



export function setCurrentUser(user) {
    console.log('function setCurrentUser() just fired...')
    // get logged in user's id
    client.writeData({
        data: { currentUserId: user.id }
    });
    getCurrentUserId();

    client.writeData({
        data: { currentUser: {...user, __typename: 'CurrentUser'} }
    });
    getCurrentUser();

    console.log('function setCurrentUser() client.client.writeData() completed');
    return true;
}

export function deleteCurrentUser() {
    console.log('function setCurrentUser() just fired...')
    // get logged in user's id
    client.writeData({
        data: { currentUserId: null }
    });
    getCurrentUserId();

    client.writeData({
        data: { currentUser: null }
    });
    getCurrentUser();

    console.log('function setCurrentUser() client.client.writeData() completed');
    return true;
}